import React, { useEffect, useState } from "react";
import {
  enterImmersiveMode,
  isFullscreenActive,
  isStandaloneDisplay,
  subscribeFullscreenChange,
  supportsElementFullscreen,
} from "../../utils/immersiveMode";
import "./style.css";

/**
 * F11-style control for landscape capture.
 * Shows until native fullscreen (or PWA standalone) is active.
 */
export default function FullscreenCapturePrompt({ targetRef }) {
  const [isFullscreen, setIsFullscreen] = useState(
    () => isFullscreenActive() || isStandaloneDisplay()
  );
  const canFullscreen = supportsElementFullscreen();

  useEffect(() => {
    if (isStandaloneDisplay()) {
      setIsFullscreen(true);
      return undefined;
    }

    return subscribeFullscreenChange(setIsFullscreen);
  }, []);

  if (isFullscreen || isStandaloneDisplay()) {
    return null;
  }

  const handleEnter = async (event) => {
    event.stopPropagation();
    const target = targetRef?.current || document.documentElement;
    const ok = await enterImmersiveMode(target);
    setIsFullscreen(ok || isFullscreenActive());
  };

  if (!canFullscreen) {
    return (
      <div className="pi-fs-prompt pi-fs-prompt--hint" role="status">
        For a full-screen view on iPhone, tap Share → Add to Home Screen, then open from there.
      </div>
    );
  }

  return (
    <button type="button" className="pi-fs-prompt" onClick={handleEnter}>
      Tap for full screen
    </button>
  );
}
